/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import TopBannerEvent from '@components/HNI/Components/Banners/TopBannerEvent';
// import CompWithLeastStyle from '@shi/styleData/CompWithLeastStyle';

/* Services */

/**
 * Renders the BenefitsGroup component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} BenefitsGroup component
 */

const TopBanner = ({ sectionContent, region, lang }) => {
  return (
    <>
      <Box>
        <TopBannerEvent sectionContent={sectionContent[0]} />
      </Box>
    </>
  );
};

export default TopBanner;
